import styled from 'styled-components';
import { Button } from '../Button';
import { rem } from '../../app/styles';

export const MainButtonFallback = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: ${rem(16)};
  z-index: 1000;
  background: var(--color-primary);
`;

export const MainButtonStyled = styled(Button)`
  width: 100%;
  border-radius: 14px;

  &:disabled {
    border-radius: 14px;
  }
`;
